// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__MlJ1r"};